import React, { Suspense, lazy } from 'react';
import { PermissionList, RolePermission, useSecondaryModal } from 'utils';
import { ClaimDetails } from '../claims';

// const ClaimDetails = lazy(() => import('../claims').then((m) => ({ default: m.ClaimDetails })));
export const OpenClaimDetails = ({ claimId, displayId, afterSuccess }) => {
    const { openSecondary, closeSecondary } = useSecondaryModal();
    const checkPermission = RolePermission([PermissionList.CLAIMS_READ.code]);

    const activeStyles = {
        color: checkPermission ? '#347AF0' : '#4B5C68',
        textDecoration: checkPermission ? 'underline' : 'none',
        width: 'fit-content',
        cursor: checkPermission ? 'pointer' : 'default',
    };

    const openClaim = () => {
        if (checkPermission) {
            openSecondary(
                        <ClaimDetails climId={claimId} afterSuccess={afterSuccess} onClose={closeSecondary} />,
                {
                    styles: {
                        bodyStyle: {
                            padding: 0,
                        },
                    },
                }
            );
        }
    };

    return (
        <p style={activeStyles} onClick={(e) => openClaim(e)}>
            {displayId}
        </p>
    );
};
